
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/importers/[...slug]",
      function () {
        return require("private-next-pages/importers/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/importers/[...slug]"])
      });
    }
  